import { db } from '../../common/config/Firebase';

/**
 * Fetches all vacations for a specific employee, ordered by start date (most recent first)
 * @param {string} employeeDni - Employee DNI
 * @returns {Promise<Array>} - Array of vacation objects
 */
export const getEmployeeVacationsUseCase = async (employeeDni) => {
    try {

        const snapshot = await db
            .collection('employeeVacations')
            .where('employeeDni', '==', employeeDni)
            .orderBy('startDate', 'desc')
            .get();

        const vacations = [];
        snapshot.forEach(doc => {
            const data = doc.data();
            vacations.push({
                id: doc.id,
                employeeDni: data.employeeDni,
                startDate: data.startDate.toDate(), // Convert Firebase Timestamp to JS Date
                endDate: data.endDate.toDate(), // Convert Firebase Timestamp to JS Date
                description: data.description || '',
                createdAt: data.createdAt ? data.createdAt.toDate() : null
            });
        });

        console.log(`Fetched ${vacations.length} vacations for employee ${employeeDni}`);
        return vacations;
    } catch (error) {
        console.error('Error fetching employee vacations:', error);
        return []; // Return empty array on error to not break the UI
    }
};
